import { Box, Divider } from '@mui/material';
import styled from 'styled-components';

export const SectionWrapper = styled(Box)`
  && {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(3)};
  }
`;

export const CustomDivider = styled(Divider)`
  && {
    margin-bottom: ${({ theme }) => theme.spacing(2)};
  }
`;

export const SectionHeader = styled(Box)`
  && {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    & svg {
      & path {
        stroke: ${({ theme }) => theme.palette.text.primary};
      }
    }
  }
`;
